import { AppState, AppThunk } from "@Store/index";
import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import fetchPlusPageData from "./fetchPlusPageData";

interface AmberPlusPageData {
  readyStatus: "invalid" | "request" | "success" | "failure";
  error: string | null;
  data: {
    featured_images: any;
    best_deals: any;
    partners: any;
    services: any;
  };
}

export const initialState: AmberPlusPageData = {
  readyStatus: "invalid",
  error: null,
  data: {
    featured_images: [],
    best_deals: [],
    partners: [],
    services: [],
  },
};

const amberPlusPageData = createSlice({
  name: "amberPlusPageData",
  initialState,
  reducers: {
    getPlusPageRequesting: (state: AmberPlusPageData) => {
      state.readyStatus = "request";

      if (__CLIENT__) {
        window.scrollTo(0, 0);
      }
    },
    getPlusPageSuccess: (state: AmberPlusPageData, { payload }: PayloadAction<any>) => {
      state.readyStatus = "success";
      state.data.best_deals = payload.data.best_deals;
      state.data.featured_images = payload.data.featured_images;
      state.data.partners = payload.data.partners;
      state.data.services = payload.data.services;
    },
    getPlusPageServicesOnly: (state: AmberPlusPageData, { payload }: PayloadAction<any>) => {
      state.data.services = payload.services;
    },
    getPlusPageFailure: (state: AmberPlusPageData, { payload }: PayloadAction<any>) => {
      state.readyStatus = "failure";
      state.error = JSON.stringify(payload);
    },
  },
});

const shouldFetchPlusPage = (state: AppState) => state.amberPlusPageData.readyStatus === "invalid";

export const fetchAmberPLusPageDataIfNeeded =
  (props: any): AppThunk =>
  (dispatch, getState: any) => {
    const href = (__CLIENT__ ? window.location.href : props.req?.url) || null;
    if (__CLIENT__) {
      if (getState().router.action === "PUSH" && __CLIENT__) {
        window.scrollTo(0, 0);
      }
      if (!props?.isApp && !shouldFetchPlusPage(getState())) return null;
    }
    let token = "";
    if (!__CLIENT__) {
      token = props.req.cookies.user_auth_token;
    }

    if (shouldFetchPlusPage(getState())) {
      return dispatch(fetchPlusPageData({ url: href, token }));
    }
    return null;
  };

export default amberPlusPageData.reducer;
export const {
  getPlusPageRequesting,
  getPlusPageSuccess,
  getPlusPageFailure,
  getPlusPageServicesOnly,
} = amberPlusPageData.actions;
